export const packages = {
  PalletEuro: { id: 1, title: "ПАЛЛЕТА ЕВРО" },
  PalletOther: { id: 2, title: "ПАЛЛЕТА ДРУГАЯ" },
  Box: { id: 3, title: "КОРОБКА" },
  Roll: { id: 4, title: "РУЛОН/ТУБУС/ПРОФИЛЬ" },
  Pyramid: { id: 5, title: "ПИРАМИДА" },
  Other: { id: 6, title: "ДРУГОЕ" },
  Pack: { id: 7, title: "ПАКЕТ" },
  WoodenBox: { id: 8, title: "ДЕРЕВЯННЫЙ КОРОБ/ЯЩИК" },
};